import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { trackEvent } from "@/lib/tracking";

/**
 * Primary "Book a meeting" CTA.
 * Always routes to /contact#booking-section so the visitor lands directly
 * on the embedded Google Workspace Calendar inside the Contact page (no
 * external tab, no two-CTA fork at the top of /contact).
 *
 * If the user is already on /contact, we smooth-scroll to the booking
 * section without a route change.
 */
export default function BookCall({
  children = "Book a meeting",
  variant = "primary", // primary | ghost-dark | ghost-light
  source = "cta",
  className = "",
  ...rest
}) {
  const { pathname } = useLocation();
  const base = "xa-btn";
  const style =
    variant === "ghost-dark"
      ? "xa-btn-ghost-dark"
      : variant === "ghost-light"
      ? "xa-btn-ghost"
      : "xa-btn-primary";
  const cls = `${base} ${style} ${className}`.trim();

  const handle = (e) => {
    trackEvent("book_call_click", { id: source });
    if (pathname === "/contact") {
      e.preventDefault();
      document
        .getElementById("booking-section")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Link
      to="/contact#booking-section"
      onClick={handle}
      data-testid={`book-call-${source}`}
      className={cls}
      {...rest}
    >
      {children} <ArrowUpRight className="w-4 h-4" />
    </Link>
  );
}
